import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faFileWord } from "@fortawesome/free-regular-svg-icons"

export const FileWordRegular = (props) => {
  return <FontAwesomeIcon faIcon={faFileWord} {...props} />
}
